import React, { useEffect, useState } from 'react';
import './app.css';
import ClipBord from '../../../assets/images/Clipboard.png';
import LatestOrder from 'components/latestOrder/LatestOrder';
import axios from 'axios';
import { formatDate } from 'pages/utils/formdatedynamics';
import { ToastContainer, toast, } from 'react-toastify';
import { Button } from 'components';
import socketOrder from 'pages/utils/SokectOrder';

function Orders() {
  const [loading, setLoading] = useState(false);
  const [ongoingOrders, setOngoingOrders] = useState([]);
  const [displayCount, setDisplayCount] = useState(8); // Initially show 8 orders

console.log(ongoingOrders,'ongoingOrdersdata')
  const fetchData = async () => {
    const token = localStorage.getItem('accessToken'); // Retrieve token from local storage
    const apiUrl = 'https://backend.washta.com/api/seller/latestOrders';

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      setOngoingOrders(response.data.data);
    } catch (err) {
      console.log(err.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    setLoading(true);
    fetchData();
  
    const handleIncomingData = (data) => {  
      setOngoingOrders(prevOrders => {
        const exists = prevOrders.some(order => order._id === data._id);
        if (exists) return prevOrders; // skip if already exists
        return [data, ...prevOrders];
      });
  
      // Optional toast
      toast.success("New order received from " + (data?.customerId?.username || "customer"));
    };
  
    socketOrder.on("newOrderBooking", handleIncomingData);
  
    return () => {
      socketOrder.off("newOrderBooking", handleIncomingData);
    };
  }, []);
  
  const handleAccept = async(orderId) => {
    const token = localStorage.getItem('accessToken');
    const url = `https://backend.washta.com/api/seller/orderStatus/${orderId}`;
    const status = 'inprocess';
  
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    };
  
    const body = {
      id: orderId,
      status: status,
    };
  
    try {
      const response = await axios.patch(url, body, { headers });
      toast.success(`Order is ${status}`)
      window.location.reload()
    } catch (error) {
      console.error('Error updating order status:', error);
    }
  };

  // Function to handle the refuse API call
  const handleRefuse = async(orderId) => {
    const token = localStorage.getItem('accessToken');
    const url = `https://backend.washta.com/api/seller/orderStatus/${orderId}`;
    const status = 'cancelled'; // or 'completed', replace with the actual status you need
  
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    };
  
    const body = {
      id: orderId,
      status: status,
    };
  
    try {
      const response = await axios.patch(url, body, { headers });
      toast.success(`Order is ${status}`)
      window.location.reload()
    } catch (error) {
      console.error('Error updating order status:', error);
    }
  };
  const Completehandle = async (id) => {
    const token = localStorage.getItem('accessToken');
    const url = `https://backend.washta.com/api/seller/orderStatus/${id}`;
    const status = 'completed';
  
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    };
  
    const body = {
      id: id,
      status: status,
    };
  
    try {
      const response = await axios.patch(url, body, { headers });
      toast.success(`Order is ${status}`)
      window.location.reload()
    } catch (error) {
      console.error('Error updating order status:', error);
    }
  };
  return (
    <div className="orders">
      <div className="chart-colm-div-heading">
        <img src={ClipBord} style={{ width: '15%', objectFit: 'contain' }} alt="Clipboard" />
        <h2 className="main-heading2">Total Orders</h2>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <div className="order-section">
            <div className="order-list">
              {/* {ongoingOrders?.map((data) => (
                <div key={data._id} style={{ marginTop: 20 }}>
                  <LatestOrder
                    Cost={data.cost}
                    OrderDate={formatDate(data?.date)}
                    OrderId={data._id.slice(0, 5)}
                    status={data.status}
                    MainName={data?.customerId?.username || "N/A"}
                    onAccept={()=>handleAccept(data._id)}
                    onRefuse={()=>handleRefuse(data._id)}
                    onComplted={()=>Completehandle(data._id)}
                  />
                </div>
              ))} */}
              {/* {ongoingOrders?.slice(0, displayCount)?.map((data) => (
  <div key={data._id} style={{ marginTop: 20 }}>
    <LatestOrder
      Cost={data?.cost}
      OrderDate={formatDate(data?.date)}
      OrderId={data?._id.slice(0, 5)}
      status={data?.status}
      MainName={data?.customerId?.username || "N/A"}
      onAccept={() => handleAccept(data?._id)}
      onRefuse={() => handleRefuse(data?._id)}
      onComplted={() => Completehandle(data?._id)}
    />
  </div>
))}
{displayCount < ongoingOrders.length && (
  <div className='flex justify-center'>

  <Button onClick={() => setDisplayCount(displayCount + 10)} className='text-[10px] w-[40%] h-[10%] mt-3 '>
    View More
  </Button>
  </div>
)} */}
{Array.isArray(ongoingOrders) && ongoingOrders.slice(0, displayCount).map((data, index) => {
  const orderId = data?._id || `temp-${index}`; // fallback key
  const orderDate = data?.date ? formatDate(data.date) : "N/A";
  const status = data?.status || "pending";
  const mainName = data?.customerId?.username || "N/A";

  return (
    <div key={orderId} style={{ marginTop: 20 }}>
      <LatestOrder
      Item={data}
        
        OrderDate={orderDate}
        OrderId={orderId.slice(0, 8)}  // slice only if it's a real ID
        status={status}
        MainName={mainName}
        onAccept={() => handleAccept(data?._id)}
        onRefuse={() => handleRefuse(data?._id)}
        onComplted={() => Completehandle(data?._id)}
      />
    </div>
  );
})}

{Array.isArray(ongoingOrders) && displayCount < ongoingOrders.length && (
  <div className='flex justify-center'>
    <Button onClick={() => setDisplayCount(displayCount + 10)} className='text-[10px] w-[40%] h-[10%] mt-3 '>
      View More
    </Button>
  </div>
)}


            </div>
          </div>

        </>
      
      )}
        <ToastContainer/>
    </div>
  );
}

export default Orders;
